import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.67858 13.9429L11.0115 4.58802L13.4063 6.98541L4.06217 16.3235H1.67858V13.9429ZM13.5685 2.02297L15.9745 4.42595L14.5981 5.80068L12.1977 3.40329L13.5685 2.02297ZM0.839291 18H4.40908C4.63289 18 4.84551 17.9106 5.00218 17.7541L17.7538 5.01832C17.9105 4.86184 18 4.6439 18 4.42595C18 4.20242 17.9105 3.99007 17.7538 3.83359L14.1616 0.245886C14.005 0.0894132 13.7924 0 13.5685 0C13.3447 0 13.1321 0.0894132 12.9754 0.245886L0.246192 13.004C0.0895244 13.1661 0 13.3785 0 13.5964V17.1618C0 17.6256 0.374883 18 0.839291 18Z"
	})
});
export default SvgEdit;
